
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/homeloans/[[...slug]]",
      function () {
        return require("private-next-pages/homeloans/[[...slug]].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/homeloans/[[...slug]]"])
      });
    }
  